import * as THREE from 'three';

export type LandscapeVersion = 'classic' | 'canyon-v2' | 'canyon-v3';

export interface LandscapeOptions {
  version?: LandscapeVersion;
}

export const DEFAULT_LANDSCAPE_VERSION: LandscapeVersion = 'canyon-v3';

export function resolveLandscapeVersion(params: URLSearchParams): LandscapeVersion {
  const landscape = params.get('landscape');
  if (landscape === 'classic' || landscape === 'canyon-v2' || landscape === 'canyon-v3') {
    return landscape;
  }
  return DEFAULT_LANDSCAPE_VERSION;
}

export function isCanyonLandscape(version: LandscapeVersion | undefined): boolean {
  const resolved = version ?? 'classic';
  return resolved === 'canyon-v2' || resolved === 'canyon-v3';
}

export function isCanyonV3Landscape(version: LandscapeVersion | undefined): boolean {
  return (version ?? 'classic') === 'canyon-v3';
}

export function canyonOpenness(distance: number, side: 1 | -1 = 1): number {
  const broad = Math.sin(distance * 0.0028 + side * 1.9) * 0.5 + 0.5;
  const medium = Math.sin(distance * 0.0072 + side * 4.7) * 0.5 + 0.5;
  const pulse = Math.sin(distance * 0.013 + side * 0.8) * 0.5 + 0.5;
  const mixed = broad * 0.58 + medium * 0.30 + pulse * 0.12;
  return THREE.MathUtils.smoothstep(mixed, 0.24, 0.86);
}

export function canyonWallDistance(openness: number): number {
  // Metres from the track wall buffer. Low openness = tight canyon throat.
  return 18 + openness * openness * 185;
}

export function canyonWallHeight(openness: number, roughness: number): number {
  const tightness = 1 - openness;
  return 8 + tightness * tightness * 68 + roughness * (10 + tightness * 26);
}
